// Ответ из письма (032: contracts/api.md, «Маршруты»; data-model.md, `answers.letter_answers`;
// research Р2, Р3; FR-005, FR-008 – FR-012; ASG-NTF-14; ADR-0047). Страница ответа по личной ссылке
// отдаётся сервером HTML-страницей без React (ADR-0020): её форма здесь не описывается. Здесь —
// итог ответа и ввод ответа контролёром по письму, которое не применилось.
import { z } from '../kernel/zod.ts';
import { IdSchema } from '../kernel/common.ts';
import { ITEM_TITLE_MAX } from '../minutes/item.ts';
import { ProgressInputSchema } from '../minutes/progress.ts';
import { DueReasonSchema } from '../control/my-items.ts';

/**
 * Итог ответа по пункту письма (FR-009 – FR-012): applied — пункт изменён; stale — пункт изменился
 * после письма; closed — пункт закрыл другой; test — письмо песочницы, пункт не меняется; failed —
 * автора ответа нет (почта занята другим человеком, учётная запись в архиве). Кроме applied — ответ
 * у контролёра во «Входящих».
 */
export const letterAnswerOutcomes = ['applied', 'stale', 'closed', 'test', 'failed'] as const;
export type LetterAnswerOutcome = (typeof letterAnswerOutcomes)[number];
export const LetterAnswerOutcomeSchema = z.enum(letterAnswerOutcomes);

/** Вид ответа со страницы: «Выполнено» и «Новый срок…». */
export const letterAnswerKinds = ['done', 'due', 'progress'] as const;
export type LetterAnswerKind = (typeof letterAnswerKinds)[number];
export const LetterAnswerKindSchema = z.enum(letterAnswerKinds);

/** Откуда ответ, который вносит контролёр: непринятый ответ со страницы, ответное письмо, строка. */
export const AnswerEnterSourceSchema = z.union([
  z.strictObject({ answerId: IdSchema }),
  z.strictObject({ replyId: IdSchema }),
  z.strictObject({ notificationId: IdSchema }),
]);
export type AnswerEnterSource = z.infer<typeof AnswerEnterSourceSchema>;

/**
 * POST /api/answers/enter (FR-005; принцип XIII — ручной ввод контролёром с пометкой источника):
 * «Выполнено» или «Новый срок…» с причиной от имени ответившего.
 */
export const AnswerEnterSchema = z.discriminatedUnion('kind', [
  z.strictObject({
    source: AnswerEnterSourceSchema,
    itemId: IdSchema,
    kind: z.literal('progress'),
    note: ProgressInputSchema.shape.text,
    commandId: IdSchema,
  }),
  z.strictObject({
    source: AnswerEnterSourceSchema,
    itemId: IdSchema,
    kind: z.literal('done'),
    commandId: IdSchema,
  }),
  z.strictObject({
    source: AnswerEnterSourceSchema,
    itemId: IdSchema,
    kind: z.literal('due'),
    dueRaw: z.string().trim().min(1).max(ITEM_TITLE_MAX),
    reason: DueReasonSchema,
    commandId: IdSchema,
  }),
]);
export type AnswerEnter = z.input<typeof AnswerEnterSchema>;

export const AnswerEnterResultSchema = z.object({ revision: z.number().int().min(1) });
export type AnswerEnterResult = z.infer<typeof AnswerEnterResultSchema>;
